<template>
<div>
    <!-- DATOS GENERALES -->
    <v-menu v-if="es_soluciona && m1" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Datos Generales':''" v-tippy>
                <v-icon>mdi-folder-information-outline</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Datos Generales</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('sa31.dg.tipoprograma')" to="/clientes/datos_contribuyente" @click.shift="openNew('/clientes/datos_contribuyente');">

                <v-icon>mdi-circle-small</v-icon> Tipo de Programa

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('sa31.dg.certificaciones')" to="/clientes/certificaciones" @click.shift="openNew('/clientes/certificaciones');">

                <v-icon>mdi-circle-small</v-icon> Expediente CIVA IEPS

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.utilerias.reglas')" to="/sa31/catalogos/reglas_plazo" @click.shift="openNew('/sa31/catalogos/reglas_plazo');">

                <v-icon>mdi-circle-small</v-icon> Reglas de Plazo

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.utilerias.reglas')" to="/sa31/catalogos/claves_distintas" @click.shift="openNew('/sa31/catalogos/claves_distintas');">
                
                <v-icon>mdi-circle-small</v-icon> Claves Distintas

            </app-bar-item>

            <app-bar-item v-if="false && valida_permiso('sa31.dg.fundamento')" to="#" @click.shift="openNew('#');">

                <v-icon>mdi-circle-small</v-icon>(x) Fundamento Legal

            </app-bar-item>

        </v-list>
    </v-menu>
    <!-- Utilerias -->
    <v-menu v-if="es_soluciona && m2" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Utilerias':''" v-tippy>
                <v-icon>dashboard</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Utilerías</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('sa31.utilerias.usuarios')" to="/catalogos/usuariossa" @click.shift="openNew('/catalogos/usuariossa');">

                <v-icon>mdi-circle-small</v-icon>Usuarios

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('sa31.utilerias.aduanas') && !soloEcosting" to="/clientes/aduanas" @click.shift="openNew('/clientes/aduanas');">

                <v-icon>mdi-circle-small</v-icon>Aduanas Cliente

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('sa31.utilerias.apendices') && !soloEcosting" to="/apendices/33" @click.shift="openNew('/apendices/33');">

                <v-icon>mdi-circle-small</v-icon>Apéndices

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.utilerias.planta') && planta_referencia " to="/catalogos/referencias" @click.shift="openNew('/catalogos/referencias');">

                <v-icon>mdi-circle-small</v-icon>Planta-Referencia

            </app-bar-item>


            <app-bar-item v-if="valida_permiso('sa31.utilerias.Log')" to="/catalogos/acceso_usuarios" @click.shift="openNew('/catalogos/acceso_usuarios');">

                <v-icon>mdi-circle-small</v-icon>Log de Accesos

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.utilerias.eNotes')" to="/catalogos/enotes" @click.shift="openNew('/catalogos/enotes');">

                <v-icon>mdi-circle-small</v-icon>eNotes

            </app-bar-item>

        </v-list>
    </v-menu>

    <!-- Data Stage -->
    <v-menu v-if="es_soluciona && m3" bottom nav offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Data Stage':''" v-on="on" v-tippy id="menuPreferenciasDS">
                <v-icon>attach_file</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Data Stage</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <app-bar-item v-if="valida_permiso('sa31.ds.carga')" to="/datastage/cargazip" @click.shift="openNew('/datastage/cargazip');">

                <v-icon>mdi-circle-small</v-icon>Carga Zip

            </app-bar-item>

            <app-bar-item v-if="valida_permiso('sa31.ds.bitacora')" to="/datastage/bitacorazip" @click.shift="openNew('/datastage/bitacorazip');">

                <v-icon>mdi-circle-small</v-icon>Bitácora ZIP

            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.ds.importar') && planta_referencia " to="/sa31/reportes/importar" @click.shift="openNew('/sa31/reportes/importar');">

                <v-icon>mdi-circle-small</v-icon>Importar Cargos

            </app-bar-item>

            <app-bar-item v-if="false &&  valida_permiso('sa31.ds.buscapedimento')"  to="/sa31/buscar_pedimento" @click.shift="openNew('/sa31/buscar_pedimento');">

                <v-icon>mdi-circle-small</v-icon>Buscar Pedimento

            </app-bar-item>

            <app-bar-item v-if="false &&  valida_permiso('sa31.ds.facturas')" to="#" @click.shift="openNew('#');">

                <v-icon>mdi-circle-small</v-icon>(x) Facturas CFDI

            </app-bar-item>
            
            <v-divider />
            <app-bar-item to="/datastage/directo_ds" @click.shift="openNew('/datastage/directo_ds');">

                <v-icon>mdi-circle-small</v-icon>Reportes Directos DS

            </app-bar-item>

            <v-divider />
            <v-menu open-on-hover offset-x nav transition="scale-transition" >
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on" >
                        <app-bar-item>
                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Predeterminados DS
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuPredeterminados" to="/sa31/datastage/predeterminados/roce" @click.shift="openNew('/sa31/datastage/predeterminados/roce');">
                        <v-icon>mdi-circle-small</v-icon> Resumen de Operaciones de CE 
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuPredeterminados" to="/sa31/datastage/predeterminados/preferencias_arancelarias" @click.shift="openNew('/sa31/datastage/predeterminados/preferencias_arancelarias');">
                        <v-icon>mdi-circle-small</v-icon> Preferencias Arancelarias
                    </app-bar-item>
                </v-list>
            </v-menu>

            <v-divider />
            <app-bar-item @click.native="downloadFile('ManualConsultaDataStage.pdf');">

                <v-icon>mdi-circle-small</v-icon>Manual Consulta DS

            </app-bar-item>
        </v-list>
    </v-menu>

    <!-- Vucem-Pedimento -->
    <v-menu v-if="es_soluciona && m4" bottom nav offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Vucem-Pedimento':''" v-on="on" v-tippy>
                <v-icon>swap_vert</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Vucem-Pedimento</span>
            </v-btn>
        </template>

        <v-list :tile="false" nav>
            <app-bar-item v-if="esSuper" @click.native="hideMenuReportes" to="/vucem/recuperacionesws" @click.shift="openNew('/vucem/recuperacionesws');">

                    <v-icon>mdi-circle-small</v-icon>Documentos Importador Exportador

            </app-bar-item>

            <v-menu v-if="valida_permiso('sa31.vucem.soia')" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuVucem">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Consulta Rápida SOIA
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuReportes" to="/vucem-pedimento/qr">
                        <v-icon>mdi-circle-small</v-icon>Consulta Rapida
                    </app-bar-item>
                    <app-bar-item @click.native="linkConsultaRapida">
                        <v-icon>mdi-circle-small</v-icon>Detalle de Cruce o Módulo del Despacho
                    </app-bar-item>

                </v-list>
            </v-menu>

            <v-divider />

            <app-bar-item v-if="valida_permiso('sa31.vucem.pedimentos')" to="/reportes/consultar_pedimentos_detalle" @click.shift="openNew('/reportes/consultar_pedimentos_detalle');">

                <v-icon>mdi-circle-small</v-icon>Pedimentos

            </app-bar-item>
           
        </v-list>
    </v-menu>

    <!-- INFORMES -->
    <v-menu v-if="es_soluciona && (m5 || m6)" nav bottom offset-y origin="center center" transition="scale-transition">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Utilerias':''" v-tippy>
                <v-icon>mdi-text-box-outline</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Informes TXT</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>
            <v-menu v-if="m5" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuNuevoInforme">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Nuevo Informe
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('sa31.txt.inicial')" @click.native="hideMenuReportes" to="/sa31/cargarinicial" @click.shift="openNew('/sa31/cargarinicial');">
                        <v-icon>mdi-circle-small</v-icon> Inventario Inicial
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.txt.descargo')" @click.native="hideMenuReportes" to="/sa31/cargartxt" @click.shift="openNew('/sa31/cargartxt');">
                        <v-icon>mdi-circle-small</v-icon> Informe de Descargo
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.txt.pedimentos')" @click.native="hideMenuReportes" to="/sa31/indexar" @click.shift="openNew('/sa31/indexar');">
                        <v-icon>mdi-circle-small</v-icon> Indexar Pedimentos - Inventario
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.txt.generador')" @click.native="hideMenuReportes" to="/sa31/generador_archivos" @click.shift="openNew('/sa31/generador_archivos');">
                        <v-icon>mdi-circle-small</v-icon> Generador de Informes TXT
                    </app-bar-item>

                </v-list>
            </v-menu>
            <v-menu v-if="m6" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuBitacora">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Bitacora Informe
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('sa31.txt.simulados')" @click.native="hideMenuReportes" to="/sa31/simulacion" @click.shift="openNew('/sa31/simulacion');">
                        <v-icon>mdi-circle-small</v-icon> Simulación de Descargos
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.txt.bitacora')" @click.native="hideMenuReportes" to="/sa31/bitacora" @click.shift="openNew('/sa31/bitacora');">
                        <v-icon>mdi-circle-small</v-icon> Informes TXT Aplicados
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.txt.papelera')" @click.native="hideMenuReportes" to="/sa31/papelera" @click.shift="openNew('/sa31/papelera');">
                        <v-icon>mdi-circle-small</v-icon> Papelera de Informes
                    </app-bar-item>

                </v-list>
            </v-menu>

        </v-list>
    </v-menu>

    <!-- Reportes -->
    <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona && (m7 || m8 || m9)">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Reportes':''" v-tippy>
                <v-icon>file_copy</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Reportes</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>

            <app-bar-item v-if="valida_permiso('sa31.reportes.eg')" to="/sa31/reportes/estado_cuenta_global" @click.shift="openNew('/sa31/reportes/estado_cuenta_global');">
                <v-icon>mdi-circle-small</v-icon>Estado de Cuenta Global
            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.reportes.ef')" to="/sa31/reportes/estado_cuenta_fracciones" @click.shift="openNew('/sa31/reportes/estado_cuenta_fracciones');">
                <v-icon>mdi-circle-small</v-icon>Estado de Cuenta por fracción
            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.reportes.sf')" to="/sa31/reportes/saldos_fracciones" @click.shift="openNew('/sa31/reportes/saldos_fracciones');">
                <v-icon>mdi-circle-small</v-icon>Reporte de saldos por fracción arancelaria e identificador de activo
            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.reportes.ct')" to="/sa31/reportes/cuentat_fraccion" @click.shift="openNew('/sa31/reportes/cuentat_fraccion');">
                <v-icon>mdi-circle-small</v-icon>Reporte detallado de cuenta de afectación “T”
            </app-bar-item>
            <app-bar-item v-if="valida_permiso('sa31.reportes.pii')" to="/sa31/reportes/partidas_inicial" @click.shift="openNew('/sa31/reportes/partidas_inicial');">
                <v-icon>mdi-circle-small</v-icon>Partidas Inventario Inicial
            </app-bar-item>

            <v-menu  open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuCargos">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Cargos
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.cargos.global')" @click.native="hideMenuReportes" to="/sa31/reportes/cargos" @click.shift="openNew('/sa31/reportes/cargos');">
                        <v-icon>mdi-circle-small</v-icon> Valor Global
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.cargos.partida')" @click.native="hideMenuReportes" to="/sa31/reportes/cargos_partidas" @click.shift="openNew('/sa31/reportes/cargos_partidas');">
                        <v-icon>mdi-circle-small</v-icon> Por Partida
                    </app-bar-item>


                </v-list>
            </v-menu>
            <v-menu  open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">

                    <span v-on="on" id="menuAbonos">
                        <app-bar-item @click.native="hideMenuReportes">

                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Abonos
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.abonos.fracc')" @click.native="hideMenuReportes" to="/sa31/reportes/abonos_fracciones" @click.shift="openNew('/sa31/reportes/abonos_fracciones');">
                        <v-icon>mdi-circle-small</v-icon> Por Fracción
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.abonos.folio')" @click.native="hideMenuReportes" to="/sa31/reportes/abonos_folio" @click.shift="openNew('/sa31/reportes/abonos_folio');">
                        <v-icon>mdi-circle-small</v-icon> Por Folio
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.abonos.rp')" @click.native="hideMenuReportes" to="/sa31/reportes/abonos_referencia_pedimento" @click.shift="openNew('/sa31/reportes/abonos_referencia_pedimento');">
                        <v-icon>mdi-circle-small</v-icon> Referencia Pedimentos
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.abonos.rd')" @click.native="hideMenuReportes" to="/sa31/reportes/abonos_referencia_documentos" @click.shift="openNew('/sa31/reportes/abonos_referencia_documentos');">
                        <v-icon>mdi-circle-small</v-icon> Referencia Otros Documentos
                    </app-bar-item>
                    <app-bar-item v-if="valida_permiso('sa31.reportes.abonos.rpa')" @click.native="hideMenuReportes" to="/sa31/reportes/abonos_referencia_partidas" @click.shift="openNew('/sa31/reportes/abonos_referencia_partidas');">
                        <v-icon>mdi-circle-small</v-icon> Referencia Partidas
                    </app-bar-item>


                </v-list>
            </v-menu>
            <app-bar-item v-if="is_reporte_saldos" to="/sa31/reportes/saldos_bimestral" @click.shift="openNew('/sa31/reportes/saldos_bimestral');">
                <v-icon>mdi-circle-small</v-icon>Reporte de Saldos
            </app-bar-item>

        </v-list>
    </v-menu>
     <!-- Auditorias -->
     <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona && m10">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on" id="menuAuditorias" :icon="fullWidth <= 1400" :title="fullWidth < 1400?'Reportes':''" v-tippy>
                <v-icon>mdi-book-search-outline</v-icon>
                <span class="caption" v-show="fullWidth > 1400">Auditorías</span>
            </v-btn>
        </template>
        <v-list :tile="false" nav>

            <v-menu v-if="valida_permiso('sa31.audit.inicial') || valida_permiso('sa31.audit.cargos')" open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on">
                        <app-bar-item>
                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Validación de Cargos
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item v-if="valida_permiso('sa31.audit.inicial')" @click.native="hideMenuAuditorias" to="/sa31/auditorias/inve_inicial" @click.shift="openNew('/sa31/auditorias/inve_inicial');">
                        <v-icon>mdi-circle-small</v-icon> Inventario Inicial
                    </app-bar-item>
                    <app-bar-item v-if="esSuper && valida_permiso('sa31.audit.cargos')" @click.native="hideMenuAuditorias" to="/sa31/auditorias/cargosds" @click.shift="openNew('/sa31/auditorias/cargosds');">
                        <v-icon>mdi-circle-small</v-icon> Auditoría/Validación Cargos
                    </app-bar-item>
                </v-list>
            </v-menu>

            <app-bar-item @click.native="hideMenuAuditorias" v-if="valida_permiso('sa31.audit.computo')" to="/sa31/auditorias/computo_plazos" @click.shift="openNew('/sa31/auditorias/computo_plazos');">
                <v-icon>mdi-circle-small</v-icon>Cómputo de Plazos
            </app-bar-item>
            <app-bar-item @click.native="hideMenuAuditorias"  to="/sa31/auditorias/fracciones_periodos" @click.shift="openNew('/sa31/auditorias/fracciones_periodos');">
                <v-icon>mdi-circle-small</v-icon>Periodo de Fracciones
            </app-bar-item>

            <app-bar-item @click.native="hideMenuAuditorias" v-if="false &&  valida_permiso('sa31.audit.confronta')" to="#" @click.shift="openNew('#');">
                <v-icon>mdi-circle-small</v-icon>(x) Confronta de Abonos
            </app-bar-item>

            <app-bar-item @click.native="hideMenuAuditorias" v-if="valida_permiso('sa31.audit.rec') && view_trafico==0 && view_costing==0" to="/rectificaciones" @click.shift="openNew('/rectificaciones');">
                <v-icon>mdi-circle-small</v-icon>Trazabilidad de rectificaciones
            </app-bar-item>


            <v-menu v-if="valida_permiso('sa31.audit.cum') " open-on-hover offset-x nav transition="scale-transition">
                <template v-slot:activator="{ attrs, on }">
                    <span v-on="on">
                        <app-bar-item>
                            <v-icon x-small>mdi-circle-small</v-icon>&nbsp; Hallazgos en Informes
                            <v-icon>mdi-menu-right</v-icon>
                        </app-bar-item>
                    </span>
                </template>
                <v-list :tile="false" nav>
                    <app-bar-item @click.native="hideMenuAuditorias"  to="/sa31/reportes/proximo_periodo" @click.shift="openNew('/sa31/reportes/proximo_periodo');">
                        <v-icon>mdi-circle-small</v-icon>Periodos Omitidos
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuAuditorias"  to="/sa31/reportes/fueraplazo" @click.shift="openNew('/sa31/reportes/fueraplazo');">
                        <v-icon>mdi-circle-small</v-icon>Informes Presentados Fuera de Plazo
                    </app-bar-item>
                    <app-bar-item @click.native="hideMenuAuditorias"  to="/sa31/reportes/novalidos" @click.shift="openNew('/sa31/reportes/novalidos');">
                        <v-icon>mdi-circle-small</v-icon>Último Informe no Válido
                    </app-bar-item>

                </v-list>
            </v-menu>


            <app-bar-item @click.native="hideMenuAuditorias" v-if="valida_permiso('sa31.audit.por')" to="/sa31/auditorias/abonos_cargos" @click.shift="openNew('/sa31/auditorias/abonos_cargos');">
                <v-icon>mdi-circle-small</v-icon>Porcentajes de Retorno
            </app-bar-item>
            <app-bar-item @click.native="hideMenuAuditorias" v-if="valida_permiso('sa31.audit.confronta')" to="/sa31/auditorias/confronta_clave" @click.shift="openNew('/sa31/auditorias/confronta_clave');">
                <v-icon>mdi-circle-small</v-icon>Confronta de valor Ped vs TXT
            </app-bar-item>
            <app-bar-item @click.native="hideMenuAuditorias" v-if="valida_permiso('sa31.audit.confronta')" to="/sa31/auditorias/abonos" @click.shift="openNew('/sa31/auditorias/abonos');">
                <v-icon>mdi-circle-small</v-icon>Folios TXT vs Valor de Abonos
            </app-bar-item>
           

      
        </v-list>
    </v-menu>
     <!-- Manual de Usuario -->
     <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="es_soluciona">
        <template v-slot:activator="{ attrs, on }">
            <v-btn text v-on="on"  title="Manual de Usuario" v-tippy>
                <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
        </template>
        <v-list :tile="false" nav>

            <app-bar-item v-if="!Admin" to="/catalogos/etipsHTMLSa31" @click.shift="openNew('/catalogos/etipsHTMLSa31');">
                <v-icon>mdi-circle-small</v-icon>Manual de Usuario
            </app-bar-item>
            <app-bar-item v-if="!Admin" to="/catalogos/etipsHTMLSa31PF" @click.shift="openNew('/catalogos/etipsHTMLSa31PF');">
                <v-icon>mdi-circle-small</v-icon>Preguntas Frecuentes
            </app-bar-item>
            <v-divider />
            <app-bar-item @click.native="downloadFile('ManualTecnicoArchviosTXT.pdf');">

                <v-icon>mdi-circle-small</v-icon>Manual Técnico Archivos TXT

            </app-bar-item>

            <app-bar-item @click.native="downloadFile('ManualOperacionInventarioInicial.pdf');">

            <v-icon>mdi-circle-small</v-icon>Manual Operación Inventario Inicial

            </app-bar-item>
            <v-divider />
            <app-bar-item v-if="!Admin" to="/videotutorial" @click.shift="openNew('/videotutorial');">

                <v-icon>mdi-circle-small</v-icon>Video Tutoriales

            </app-bar-item>

        </v-list>
    </v-menu>

</div>
</template>

<script>
// Components
import {
    VHover,
    VListItem
} from "vuetify/lib";

// Utilities
import {
    mapState,
    mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";

export default {
    name: "menuSa31",

    created() {

        this.$local_storage.set("es_emanifiesto_logistico", this.$local_storage.get("EmanifiestoMV.bitacora") == 100);

    },
    components: {

        AppBarItem: {
            render(h) {
                return h(VHover, {
                    scopedSlots: {
                        default: ({
                            hover
                        }) => {
                            return h(
                                VListItem, {
                                    attrs: this.$attrs,
                                    class: {
                                        "black--text": !hover,
                                        "white--text secondary elevation-12": hover
                                    },
                                    props: {
                                        activeClass: "",
                                        dark: hover,
                                        link: true,
                                        ...this.$attrs
                                    }
                                },
                                this.$slots.default
                            );
                        }
                    }
                });
            }
        }
    },

    props: {
        value: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        fab: false,

        show_loading: false,
        notificationsNumber: 0,
        show: true,
        rfc: "",
        razon: "",
        tipo_usuario: "",
        id_cliente: 0,
        minifiedLeft: false,
        hiddenLeft: false,
        avatar: "undefined",

        notifications: [
            "Mike John Responded to your email",
            "You have 5 new tasks",
            `You're now friends with Andrew`,
            "Another Notification",
            "Another one"
        ]
    }),

    computed: {
        ...mapState(["drawer"]),
        fullWidth(){
            return  document.documentElement.clientWidth;
        },
        view_trafico() {
            return this.$store.state.trafico;
        },
        view_costing() {
            return this.$store.state.costing;
        },
        view_emanifiesto() {
            return this.$store.state.emanifiesto;
        },
        view_carta_porte() {
            return this.$store.state.carta_porte;
        },
        view_sa31() {
            return this.$store.state.sa31;
        },
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        soloEcosting() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 && this.$local_storage.get("Reportes.ecosting.consulta.facturas") == 100;
        },
        planta_referencia() {
            return  this.$local_storage.get("Modulo16") == 100 ;
        },
        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 &&
                this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 &&
                this.$local_storage.get("EmanifiestoCP.bitacora") == 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") == 100) && this.$local_storage.get("Modulo18") != 100;
        },
        es_transportista() {
            return this.$local_storage.get("es_transportista") == 1;
        },
        solo_soluciona() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100
            && this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
            this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 && this.$local_storage.get("Modulo6") != 100 &&
             (this.$local_storage.get("EmanifiestoMV.bitacora") != 100 ) && this.$local_storage.get( "Logistica.nuevoregistro" ) != 100
             && (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100)  && this.$local_storage.get("Modulo18") != 100;
        },
        /*     es_soluciona() {
                return
                this.view_sa31 == 1 &&
                    this.view_costing == 0 &&
                    this.view_emanifiesto == 0 &&
                    this.view_carta_porte == 0 &&
                    this.view_trafico == 0 &&
                    this.$local_storage.get("id_cliente") > 0 &&
                    this.$local_storage.get("Modulo14") != 100;
            }, */
        es_soluciona() {
            return this.solo_soluciona || (this.view_sa31 == 1 &&
                this.view_costing == 0 &&
                this.view_emanifiesto == 0 &&
                this.view_carta_porte == 0 &&
                this.view_trafico == 0) && this.$local_storage.get("id_cliente") > 0;
        },

        rfc_transportista() {
            return this.$local_storage.get("rfc_grupo");;
        },
        Admin() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
                this.$local_storage.get("id_cliente") == 0
            );
        },
        esSuper() {
            return (
                this.$local_storage.get("tipo_usuario") == "Super Usuario"
            );
        },
        Legal() {
            return (this.$local_storage.get("tipo_usuario") == "Asuntos Legales");
        },
        Pagos() {
            return (this.$local_storage.get("tipo_usuario") == "Pagos");
        },
        soloCartaPorte() {
            return (this.$local_storage.get("soloCartaPorte") == 100);
        },
        m1() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.dg.tipoprograma") ||
                    this.valida_permiso("sa31.dg.certificaciones") ||
                    this.valida_permiso("sa31.dg.fundamento")
                )
            );
        },
        m2() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.utilerias.usuarios") ||
                    this.valida_permiso("sa31.utilerias.aduanas") ||
                    this.valida_permiso("sa31.utilerias.apendices") ||
                    this.valida_permiso("sa31.utilerias.planta") ||
                    this.valida_permiso("sa31.utilerias.Log") ||
                    this.valida_permiso("sa31.utilerias.eNotes")

                )
            );
        },
        m3() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.ds.carga") ||
                    this.valida_permiso("sa31.ds.bitacora") ||
                    this.valida_permiso("sa31.ds.facturas")

                )
            );
        },
        m4() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.vucem.solicitud") ||
                    this.valida_permiso("sa31.vucem.soia") ||
                    this.valida_permiso("sa31.vucem.pedimentos")

                )
            );
        },
        m5() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.txt.inicial") ||
                    this.valida_permiso("sa31.txt.descargo") ||
                    this.valida_permiso("sa31.txt.pedimentos") ||
                    this.valida_permiso("sa31.txt.generador")

                )
            );
        },
        m6() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.txt.simulados") ||
                    this.valida_permiso("sa31.txt.bitacora") ||
                    this.valida_permiso("sa31.txt.papelera")

                )
            );
        },
        m7() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.reportes.eg") ||
                    this.valida_permiso("sa31.reportes.ef") ||
                    this.valida_permiso("sa31.reportes.sf") ||
                    this.valida_permiso("sa31.reportes.ct") ||
                    this.valida_permiso("sa31.reportes.pii")

                )
            );
        },
        m8() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.reportes.cargos.global") ||
                    this.valida_permiso("sa31.reportes.cargos.partida")

                )
            );
        },
        m9() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.reportes.abonos.fracc") ||
                    this.valida_permiso("sa31.reportes.abonos.folio") ||
                    this.valida_permiso("sa31.reportes.abonos.rp") ||
                    this.valida_permiso("sa31.reportes.abonos.rd") ||
                    this.valida_permiso("sa31.reportes.abonos.rpa")

                )
            );
        },
        m10() {
            return (
                this.$local_storage.get("id_cliente") > 0 &&
                (
                    this.valida_permiso("sa31.audit.computo") ||
                    this.valida_permiso("sa31.audit.confronta") ||
                    this.valida_permiso("sa31.audit.rec") ||
                    this.valida_permiso("sa31.audit.cum")

                )
            );
        },



        is_reporte_saldos() {
            return (
                this.$local_storage.get("id_cliente") > 0 && ["AAM9712016M2","AMM060130M44","AEM000515F97","MSC990408KV1","MSC9910255Y4"].includes(this.$local_storage.get("rfc"))
            );
        },
        is_consignatario() {
            return this.$local_storage.get("perfil_grupo") == 43;
        },


        is_cliente() {
            return (
                this.$local_storage.get("id_cliente") > 0
            );
        },
        is_cliente_bosch() {
            return (
                this.$local_storage.get("id_cliente") > 0 && this.$local_storage.get("rfc") == "RBS980129FQ5"
            );
        },


        esGrupo() {
            return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
        },

    },

    methods: {
        ...mapMutations({
            setDrawer: "SET_DRAWER"
        }),
        valida_permiso(permiso) {
            return (
                this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0 
            );
        },
        valida_permiso_t(permiso) {
            return (
                this.$local_storage.get(permiso) == 100
            );
        },
        linkConsultaRapida: function () {

            //   window.open("https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_consultarap_cep.aspx", "_blank");
            window.open("https://aplicacionesc.mat.sat.gob.mx/SOIA_CR_WEB/oia_consultarap_cep.aspx", "_blank");

        },
        linkConsultaA24: function () {
            let email = this.$local_storage.get("email");
            let link = "https://integra24.mx/A24/ReportesA24U?USU=" + email;
            window.open(link, "_blank");
        },

        openNew: function (h) {
            window.open(h, "_blank");
        },

        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('Espere un momento por favor..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        hideMenuReportes: function () {

            var menu1 = document.getElementById("menuNuevoInforme");

            var menu2 = document.getElementById("menuVucem");
            var menu3 = document.getElementById("menuCargos");
            var menu4 = document.getElementById("menuAbonos");
            var menu5 = document.getElementById("menuNuevoInforme");

            if (menu1) {
                menu1.click();
            }


            if (menu2) {
                menu2.click();
            }

            if (menu3) {
                menu3.click();
            }
            if (menu4) {
                menu4.click();
            }
            if (menu5) {
                menu5.click();
            }

        },
        hideMenuAuditorias: function () {

            var menu1 = document.getElementById("menuAuditorias");
            if (menu1) {
                menu1.click();
            }
        },
        hideMenuPredeterminados: function () {
            var menu1 = document.getElementById("menuPreferenciasDS");
            if (menu1) {
                menu1.click();
            }
        },
    },

};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 5px;
    text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
    padding-left: 10px !important;
}
</style>
